export default "__VITE_ASSET__BjbvLqvN__"